var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}})
}
var staticRenderFns = []

export { render, staticRenderFns }